/* oxlint-disable no-console */

import { isSSR } from '../is-ssr.js';

export type DecodedInstance = {
  instanceId: string;
  appDefId: string;
  string?: Date;
  metaSiteId: string;
  uid: string;
  siteOwnerId: string;
};

const baseDecodedInstance = {
  instanceId: '',
  appDefId: '',
  metaSiteId: '',
  uid: '',
  siteOwnerId: '',
};

function splitInstance(instance: string) {
  console.assert(instance, 'instance is mandatory');

  const splitted = instance.split('.');
  console.assert(splitted.length >= 2, 'instance must contain data and signature separated by .');

  const data = splitted.reduce(
    (longest, current) => (current.length > longest.length ? current : longest),
    ''
  );

  return data;
}

export function parseInstance(instance?: string): DecodedInstance {
  if (!instance) {
    return baseDecodedInstance;
  }

  try {
    const data = splitInstance(instance);
    const bit64Data = isSSR()
      ? // Accessing 'Buffer' via 'global' prevents webpack polyfilling it for web environment
        global.Buffer.from(data, 'base64').toString('utf8')
      : atob(data);
    const decodedInstance = JSON.parse(bit64Data);

    if (decodedInstance.data) {
      return {
        ...baseDecodedInstance,
        ...JSON.parse(decodedInstance.data).instance,
      };
    }

    return {
      ...baseDecodedInstance,
      ...decodedInstance,
    };
  } catch {
    return baseDecodedInstance;
  }
}
